function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.253.801a.6.6 0 010 .849L8.13 6.77a1.6 1.6 0 01-2.262 0l-5.12-5.12a.6.6 0 11.849-.848l5.12 5.12a.4.4 0 00.565 0L12.404.8a.6.6 0 01.849 0z",
  fill: "currentColor"
});

function SvgDownChevron(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 8,
    viewBox: "0 0 14 8",
    fill: "none"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iOCIgdmlld0JveD0iMCAwIDE0IDgiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTMuMjUyNyAwLjgwMTE2M0MxMy40ODcgMS4wMzU0OCAxMy40ODcgMS40MTUzOCAxMy4yNTI3IDEuNjQ5NjlMOC4xMzEzNiA2Ljc3MTAyQzcuNTA2NTIgNy4zOTU4NSA2LjQ5MzQ1IDcuMzk1ODUgNS44Njg2MSA2Ljc3MTAyTDAuNzQ5MTYxIDEuNjUxNTZDMC41MTQ4NDcgMS40MTcyNSAwLjUxNDg0NyAxLjAzNzM1IDAuNzQ5MTYxIDAuODAzMDM0QzAuOTgzNDc2IDAuNTY4NzE5IDEuMzYzMzggMC41Njg3MTkgMS41OTc2OSAwLjgwMzAzNEw2LjcxNzE0IDUuOTIyNDlDNi44NzMzNSA2LjA3ODcgNy4xMjY2MiA2LjA3ODcgNy4yODI4MyA1LjkyMjQ5TDEyLjQwNDIgMC44MDExNjNDMTIuNjM4NSAwLjU2Njg0OCAxMy4wMTg0IDAuNTY2ODQ5IDEzLjI1MjcgMC44MDExNjNaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KPC9zdmc+Cg==";
export { SvgDownChevron as ReactComponent };